export function defaultLocation() {
  return { mode: "all", institutions: [], cities: {}, statesOnly: {} };
}
